import KineticMaterialBase from 'eflex/models/kinetic-material-base';
import { belongsTo } from '@ember-data/model';
import { isEmpty } from '@ember/utils';
import { service } from '@ember/service';

export default class KineticAssemblyMaterial extends KineticMaterialBase {
  @service intl;

  @belongsTo('kinetic-job-assembly', { inverse: 'materials', async: false }) assembly;

  get issuedMaterial() {
    return this.assembly.issuedMaterials.find(issue => {
      return issue.materialSequence === this.sequence &&
        issue.partNumber === this.partNumber &&
        issue.relatedOperation === this.relatedOperation;
    });
  }

  get quantityIssued() {
    if (isEmpty(this.issuedMaterial)) {
      return 0;
    }

    return `${this.issuedMaterial.issuedQuantity}/${this.issuedMaterial.requiredQuantity}`;
  }

  get issuedComplete() {
    return this.issuedMaterial?.issuedComplete ? this.intl.t('True') : this.intl.t('value.false');
  }
}
